/**
 * WalkAndPunch API
 * This is the WalkAndPunch API
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ProjectTemplateViewModel } from './projectTemplateViewModel';

export interface UserLoginViewModel { 
    id?: string;
    email?: string;
    name?: string;
    phone?: string;
    company?: string;
    globalRole?: string;
    projectsTemplates?: Array<ProjectTemplateViewModel>;
    isOrganizer?: boolean;
}